import React, { useEffect, memo } from 'react';
import { Snackbar,Alert,IconButton } from '@mui/material';
import {Close as CloseIcon} from '@mui/icons-material';
import { LabelPlacement, AlertTypes } from '../types';
import './styles.scss';

export interface AlertComponentProps {
  labelPlacement?: LabelPlacement;
  id: string;
  children: React.ReactNode | string;
  type: AlertTypes;
  isOpen: boolean;
  handleClose: () => void;
}

export const AlertComponent: React.FC<AlertComponentProps> = ({
  id,
  children = 'Sample massege',
  type = 'error',
  isOpen,
  handleClose,
}: AlertComponentProps) => {
  useEffect(() => {
    const timeId = setTimeout(() => {
      handleClose();
    }, 6000); // 6 sec

    return () => {
      clearTimeout(timeId);
    };
  }, []);

  return (
    <Snackbar
      open={isOpen}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        severity={type}
        className="root"
        id={id}
        // variant="filled"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => handleClose()}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {children}
      </Alert>
    </Snackbar>
  );
};

export default memo((AlertComponent));
